import React, {} from "react";
import {safeHTML} from "../../../../utils/safeHTML";
import classNames from "classnames";
import Icon from "../../../baseComponents/gui/icon/Icon";
import {useRouter} from "next/router";
import styles from "./Tag.module.scss";


const Tag = React.forwardRef(
  function NewsTag({type, value,color,href, mod}, ref) {

    const router = useRouter()
    const condition = type === "time" || type === "views" || type === "likes" || type === "comments";


    return (
      <div className={classNames(styles.tag, {
        [styles[`tag_${type}`]]: type,
        [styles[`tag_${mod}`]]: mod
      })} style={{background:color,cursor:href ? 'pointer' : 'auto'}} ref={ref} onClick={()=>{
        if(!href) return
        router.push(href);
      }}>
        {condition && <div className={styles.tag__icon}><Icon name={`news/${type}`}/></div>}
        <div className={styles.tag__name}>{safeHTML(value || 0)}</div>
      </div>
    );
  });
export default Tag;
Tag.propTypes = {};

